import { render, staticRenderFns } from "./meterinfoparams.vue?vue&type=template&id=2ec5f6b4&scoped=true&"
import script from "./meterinfoparams.vue?vue&type=script&lang=ts&"
export * from "./meterinfoparams.vue?vue&type=script&lang=ts&"
import style0 from "./meterinfoparams.vue?vue&type=style&index=0&id=2ec5f6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5f6b4",
  null
  
)

component.options.__file = "meterinfoparams.vue"
export default component.exports